import React, { useEffect, useState } from 'react'
import { track } from '@vercel/analytics'
import { loadDetailText } from '../utils/poiDataLoader.js'

export default function POI_Window({ secData, poiData, onClose, isClosing = false, closeDirection = 'bottom' }) {
  const [detailMaps, setDetailMaps] = useState(null)

  useEffect(() => {
    loadDetailText().then(maps => setDetailMaps(maps))
  }, [])

  if (!poiData) return null

  const popupClass = isClosing
    ? (closeDirection === 'bottom' ? 'window hide-bottom' : 'window hide')
    : 'window show'

  const handleProductClick = (e, product) => {
    if (product.link && product.link !== '#' && product.link !== 'n/a') {
      track('product_clicked', {
        productName: product.name,
        category: poiData?.category || 'Unknown',
        link: product.link
      })
    } else {
      e.preventDefault()
    }
  }

  const handleBackClick = () => {
    track('poi_popup_back_clicked', {
      section: secData?.section,
      category: poiData.category
    })

    if (poiData.poiName === 'POI010') {
      window.dispatchEvent(new CustomEvent('poi-back-to-subsection', {
        detail: { fromPoi: 'POI010', returnToSec: 'SEC004' }
      }))
    } else if (poiData.poiName === 'POI015') {
      window.dispatchEvent(new CustomEvent('poi-back-to-subsection', {
        detail: { fromPoi: 'POI015', returnToSec: 'SEC005' }
      }))
    }

    onClose()
  }

  return (
    <div className={popupClass}>
      <div className="heading">{poiData.displayTitle || poiData.category || 'POI'}</div>

      {/* Category-level description (Level 3) — shown once above the product list, not on placeholder */}
      {!poiData.isPlaceholder && detailMaps?.categoryMap?.get(poiData.category) && (
        <div className="poi-product-detail poi-category-detail">
          <p>{detailMaps.categoryMap.get(poiData.category)}</p>
        </div>
      )}

      <div className="body">
        {poiData.isPlaceholder ? (
          <>
            {detailMaps?.sectionMap?.get(poiData.category) && (
              <div className="poi-product-detail poi-category-detail">
                <p>{detailMaps.sectionMap.get(poiData.category)}</p>
              </div>
            )}
          </>
        ) : poiData.products && poiData.products.length > 0 ? (
          <div className="poi-products-list">
            {poiData.products.map((product, idx) => {
              // Per-product description (Level 4) — SEC006 per-marker text
              const productDetailText = detailMaps?.productMap?.get(product.name) || null
              const hasLink = product.link && product.link !== '#' && product.link !== 'n/a'
              return (
                <div key={idx} className="poi-product-row-wrapper">
                  {productDetailText && (
                    <div className="poi-product-detail">
                      <p>{productDetailText}</p>
                    </div>
                  )}
                  {hasLink && (
                    <a
                      href={product.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="poi-product-row"
                      onClick={(e) => handleProductClick(e, product)}
                    >
                      <div className="poi-product-row-content">
                        {product.icon && (
                          <img
                            src={product.icon}
                            alt=""
                            className="poi-product-icon"
                            onError={(e) => (e.target.style.display = 'none')}
                          />
                        )}
                        <span className="poi-product-name">{product.name}</span>
                      </div>
                      <div className="poi-product-arrow arrowButton" />
                    </a>
                  )}
                  {!hasLink && (
                    <div className="poi-product-row poi-product-row--no-link">
                      <div className="poi-product-row-content">
                        {product.icon && (
                          <img
                            src={product.icon}
                            alt=""
                            className="poi-product-icon"
                            onError={(e) => (e.target.style.display = 'none')}
                          />
                        )}
                        <span className="poi-product-name">{product.name}</span>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        ) : (
          'No products listed for this POI.'
        )}
      </div>

      <div className="buttonRow">
        <div className="backButton" onClick={handleBackClick}>
          BACK
        </div>
      </div>
    </div>
  )
}
